import * as actionTypes from "./actionTypes";
import { GeneralType } from "../../lib/types";

export const initState = () => ({
  type: actionTypes.INIT_STATE,
});

export const setState = (initialState: any) => ({
  type: actionTypes.SET_STATE,
  initialState
});

export const updateState = (updatedState: any) => ({
  type: actionTypes.UPDATE_STATE,
  updatedState
});

export const updatePopulation = (populationUpdate: any) => ({
  type: actionTypes.UPDATE_POPULATION,
  populationUpdate
});

export const updateDevelopment = (developmentUpdate: any) => ({
  type: actionTypes.UPDATE_DEVELOPMENT,
  developmentUpdate
})

export const updateResources = ({ resources, resourceBalances }: any) => ({
  type: actionTypes.UPDATE_RESOURCES,
  resources,
  resourceBalances
});

export const updateGeneral = (general: GeneralType) => ({
  type: actionTypes.UPDATE_GENERAL,
  general
});

export const updateGenerals = (generals: GeneralType[]) => ({
  type: actionTypes.UPDATE_GENERAL,
  generals
});

export const addTile = (tile: any) => ({
  type: actionTypes.ADD_TILE,
  tile
});

export const updateSlot = (slotId: number, slotUpdate: any, slotChains? : any) => ({
  type: actionTypes.UPDATE_SLOT,
  slotUpdate,
  slotId,
  slotChains
});

export const removeNotification = (notId: number) => ({
  type: actionTypes.REMOVE_NOTIFICATION,
  notId
});

export const updateNotificationsSeen = () => ({
  type: actionTypes.UPDATE_NOTIFICATIONS_SEEN
});

export const purchaseTile = (tileType: number) => ({
  type: actionTypes.PURCHASE_TILE,
  tileType
});

export const expandTile = (tileId: number) => ({
  type: actionTypes.EXPAND_TILE,
  tileId
});

export const hirePop = (slotId: number) => ({
  type: actionTypes.HIRE_POP,
  slotId
});

export const releasePop = (slotId: number) => ({
  type: actionTypes.RELEASE_POP,
  slotId
});

export const buildBuilding = (slotId: number, buildingTypeId: number) => ({
  type: actionTypes.BUILD_BUILDING,
  slotId,
  buildingTypeId
})

export const upgradeBuilding = (slotId: number, buildingTypeId: number) => ({
  type: actionTypes.UPGRADE_BUILDING,
  slotId,
  buildingTypeId
});

export const demolishBuilding = (slotId: number) => ({
  type: actionTypes.DEMOLISH_BUILDING,
  slotId
});

export const cancelBuildingDemolition = (slotId: number) => ({
  type: actionTypes.CANCEL_BUILDING_DEMOLITION,
  slotId
});

export const repairBuilding = (slotId: number) => ({
  type: actionTypes.REPAIR_BUILDING,
  slotId
});

export const nextTurn = () => ({
  type: actionTypes.NEXT_TURN
});

export const questListViewed = () => ({
  type: actionTypes.QUEST_LIST_VIEWED
});

export const finishQuest = (questId: number) => ({
  type: actionTypes.FINISH_QUEST,
  questId
});

export const boostHappiness = (gold: number) => ({
  type: actionTypes.BOOST_HAPPINESS,
  gold
});

export const setNotificationsSeen = () => ({
  type: actionTypes.SET_NOTIFICATION_SEEN
});

export const setNotificationRead = (notId: number) => ({
  type: actionTypes.SET_NOTIFICATION_READ,
  notId
});
